import React, { PropTypes } from 'react';

import SuggestionItem from './SuggestionItem';


const SearchSuggestionGroup = ({
    suggestion,
    handleClick,
    pageType,
    offset,
    selectedIndex,
    handleItemEnter,
    handleItemLeave,
    enterPressed
}) => {
    const { name, type, contents } = suggestion;
    const suggestionHeader = type !== 'terms' ? (<div className="search_results__header">{name}</div>) : null;
    const classNames = type !== 'terms' ?
        'search_results__suggestions search_results__suggestions--cat' :
        'search_results__autocomplete';
    const suggestionText = contents.map((content, index) => (
        <SuggestionItem
            content={content}
            handleClick={handleClick}
            isSelected={offset + index === selectedIndex}
            handleItemEnter={handleItemEnter}
            handleItemLeave={handleItemLeave}
            index={offset + index}
            pageType={pageType}
            enterPressed={enterPressed}
        />
    ));
    return (
        <div>
            {suggestionHeader}
            <ul className={classNames}>
                {suggestionText}
            </ul>
        </div>
    );
};

SearchSuggestionGroup.propTypes = {
    handleClick: PropTypes.func,
    suggestion: PropTypes.object,
    pageType: PropTypes.string,
    offset: PropTypes.number,
    selectedIndex: PropTypes.number,
    handleItemEnter: PropTypes.func,
    handleItemLeave: PropTypes.func,
    enterPressed: PropTypes.bool
};

export default SearchSuggestionGroup;



// WEBPACK FOOTER //
// ./app/common/search/SearchSuggestionGroup.js